import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Header from "../../../layout/Header/Header";
import Get from "../../Get";

function ConvertirArticulos() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_PRE_ARTICULOS = import.meta.env.VITE_URL_PRE_ARTICULOS;
  const URL_INVENTARIOS = import.meta.env.VITE_URL_INVENTARIOS;
  const URL_LINEAS = import.meta.env.VITE_URL_LINEAS;
  const URL_MARCAS = import.meta.env.VITE_URL_MARCAS;
  const URL_FAMILIAS = import.meta.env.VITE_URL_FAMILIAS;
  const URL_COLECCIONES = import.meta.env.VITE_URL_COLECCIONES;
  const URL_PROVEEDORES = import.meta.env.VITE_URL_PROVEEDORES;
  const URL_COLORES = import.meta.env.VITE_URL_COLORES;
  const URL_TALLAS = import.meta.env.VITE_URL_TALLAS;
  const URL_ARTICULOS_PROPORCION =
    import.meta.env.VITE_URL_ARTICULOS_PROPORCION;
  const URL_ARTICULOS = import.meta.env.VITE_URL_ARTICULOS;

  const [codigo, setCodigo] = useState("");
  const [nombre, setNombre] = useState("");
  const [piezasPorCaja, setPiezasPorCaja] = useState("");
  const [costoUSD, setCostoUSD] = useState("");
  const [costoMX, setCostoMX] = useState("");
  const [venta, setVenta] = useState("");
  const [utilidadP, SetUtilidadP] = useState();
  const [utilidadM, setUtilidadM] = useState();
  const [lista1, setLista1] = useState("");
  const [lista2, setLista2] = useState("");
  const [lista3, setLista3] = useState("");
  const [lista4, setLista4] = useState("");
  const [codigoSAT, setCodigoSAT] = useState("NA");
  const [codigoUnidad, setCodigoUnidad] = useState("PZ");
  const [observaciones, setObservaciones] = useState("NA");
  const [lineas, setLineas] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [familias, setFamilias] = useState([]);
  const [colecciones, setColecciones] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [precioEsp, setPrecioEsp] = useState("");
  const [ano, setAno] = useState("");
  const [EAN, setEAN] = useState("");
  const [selectedLinea, setSelectedLinea] = useState("");
  const [selectedMarca, setSelectedMarca] = useState("");
  const [selectedFamilia, setSelectedFamilia] = useState("");
  const [selectedColeccion, setSelectedColeccion] = useState("");
  const [selectedProveedor, setSelectedProveedor] = useState("");

  const [preArticulos, setPreArticulos] = useState([]);
  const [preArticulo, setPreArticulo] = useState("");

  const [colores, setColores] = useState([]);
  const [tallas, setTallas] = useState([]);
  const [customSizeOrder, setCustomSizeOrder] = useState([]);

  const [modalColores, setModalColores] = useState(false);
  const toggleColores = () => setModalColores(!modalColores);
  const [arrayColores, setArrayColores] = useState([]);

  const [modalTallas, setModalTallas] = useState(false);
  const toggleTallas = () => setModalTallas(!modalTallas);
  const [arrayTallas, setArrayTallas] = useState([]);

  const [amounts, setAmounts] = useState([]);
  const [validaBoton, setValidaBoton] = useState(false);

  let hoy = new Date();
  hoy.setDate(hoy.getDate() - 3650);
  const year = hoy.getFullYear();
  const years = Array.from(new Array(40), (val, index) => index + year);

  const [lastChanged, setLastChanged] = useState(null);


  // Single useEffect that handles both cases
  useEffect(() => {
    // Check which value changed and update accordingly
    if (lastChanged === "utilidadP") {
      // Calculate based on utilidadP
      const newUtilidadM = parseFloat(costoMX) * (utilidadP / 100);
      setUtilidadM(newUtilidadM);

      // Calculate venta price
      const newVenta = parseFloat(costoMX) + newUtilidadM;
      setVenta(newVenta.toFixed(2));
      setLista1(newVenta.toFixed(2));
      setLista2(newVenta.toFixed(2));
      setLista3(newVenta.toFixed(2));
      setLista4(newVenta.toFixed(2));
    } else if (lastChanged === "utilidadM") {
      // Calculate based on utilidadM
      const newUtilidadP = ((utilidadM / costoMX) * 100).toFixed(2);
      SetUtilidadP(newUtilidadP);

      // Calculate venta price
      const newVenta = parseFloat(costoMX) + parseFloat(utilidadM);
      setVenta(newVenta.toFixed(2));
      setLista1(newVenta.toFixed(2));
      setLista2(newVenta.toFixed(2));
      setLista3(newVenta.toFixed(2));
      setLista4(newVenta.toFixed(2));
    }
  }, [costoMX, utilidadP, utilidadM, lastChanged]);

  useEffect(() => {
    axios
      .get(URL_PRE_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allPrearticulos = res.data;
        // filter it by esModelo == "No"
        const filteredPreArticulos = allPrearticulos.filter(
          (preArticulo) => preArticulo.esModelo === "No"
        )
        setPreArticulos(filteredPreArticulos);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_LINEAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allLineas = res.data;
        setLineas(allLineas);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_MARCAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allMarcas = res.data;
        setMarcas(allMarcas);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_FAMILIAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allFamilias = res.data;
        setFamilias(allFamilias);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COLECCIONES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColecciones = res.data;
        setColecciones(allColecciones);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(`${URL_PROVEEDORES}Tipo/China`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allProveedores = res.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COLORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColores = res.data;
        setColores(allColores);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTallas = res.data;
        setTallas(allTallas);
            const customeSizeOrder = allTallas
          .map((t) => t.name)
        setCustomSizeOrder(customeSizeOrder);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // Fix for the useEffect that loads pre-articulo data
  useEffect(() => {
    if (preArticulo) {
      axios
        .get(`${URL_PRE_ARTICULOS}/${preArticulo}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const preArticuloData = res.data;

          axios
            .get(`${URL_ARTICULOS}/check/${preArticuloData.codigo}`, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((res) => {
              if (res.data == "si"){
                Swal.fire({
                  icon: "error",
                  title: "Error",
                  text: "El código ya está registrado en un artículo existente",
                })
              }
              return;
            })
            .catch((err) => {
              console.log(err);
            });

         setValidaBoton(true);

          // Populate the form fields with the selected pre-articulo data
          setCodigo(preArticuloData.codigo || "");
          setNombre(preArticuloData.nombre || "");
          setPiezasPorCaja(preArticuloData.piezasPorCaja || "");
          setCostoUSD(preArticuloData.costoUSD || "");
          setCostoMX(preArticuloData.costoMX || "");
          setVenta(preArticuloData.venta || "");
          SetUtilidadP(preArticuloData.utilidadP || "");
          setUtilidadM(preArticuloData.utilidadM || "");
          setLista1(preArticuloData.lista1 || "");
          setLista2(preArticuloData.lista2 || "");
          setLista3(preArticuloData.lista3 || "");
          setLista4(preArticuloData.lista4 || "");
          setCodigoSAT(preArticuloData.codigoSAT || "NA");
          setCodigoUnidad(preArticuloData.codigoUnidad || "PZ");
          setObservaciones(preArticuloData.observaciones || "NA");
          setEAN(preArticuloData.EAN || "");
          setAno(preArticuloData.ano || "");

          // Set dropdown selections based on the first item in each array
          if (preArticuloData.lineas && preArticuloData.lineas.length > 0) {
            setSelectedLinea(preArticuloData.lineas[0]._id || "");
          }

          if (preArticuloData.marcas && preArticuloData.marcas.length > 0) {
            setSelectedMarca(preArticuloData.marcas[0]._id || "");
          }

          if (preArticuloData.familias && preArticuloData.familias.length > 0) {
            setSelectedFamilia(preArticuloData.familias[0]._id || "");
          }

          if (
            preArticuloData.colecciones &&
            preArticuloData.colecciones.length > 0
          ) {
            setSelectedColeccion(preArticuloData.colecciones[0]._id || "");
          }

          if (
            preArticuloData.proveedores &&
            preArticuloData.proveedores.length > 0
          ) {
            setSelectedProveedor(preArticuloData.proveedores[0]._id || "");
          }

          // Handle color selections - Extract from the color objects in the response
          if (preArticuloData.colores && preArticuloData.colores.length > 0) {
            const selectedColores = preArticuloData.colores.map((color) => ({
              id: color._id,
              name: color.name,
            }));

            setArrayColores(selectedColores);
          }

          // Handle size selections - Extract from the size objects in the response
          if (preArticuloData.tallas && preArticuloData.tallas.length > 0) {
            const selectedTallas = preArticuloData.tallas.map((talla) => ({
              id: talla._id,
              name: talla.name,
            }));

            setArrayTallas(selectedTallas);
          }

          // Fetch the proportions data for the selected pre-articulo
          return axios.get(
            `${URL_ARTICULOS_PROPORCION}PreArticulos/${preArticulo}`,
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );
        })
        .then((res) => {
          if (res && res.data) {
            const proportionsData = res.data;
            console.log("Proportions data:", proportionsData);

            // Format the data for the grid based on the structure of your proportions data
            const formattedAmounts = proportionsData
              .map((item) => {
                let sizeId, colorId;

                // Handle different possible data structures for tallas
                if (item.tallas) {
                  if (Array.isArray(item.tallas) && item.tallas.length > 0) {
                    sizeId = item.tallas[0]._id;
                  } else if (typeof item.tallas === "string") {
                    sizeId = item.tallas;
                  } else if (item.tallas._id) {
                    sizeId = item.tallas._id;
                  }
                }

                // Handle different possible data structures for colores
                if (item.colores) {
                  if (Array.isArray(item.colores) && item.colores.length > 0) {
                    colorId = item.colores[0]._id;
                  } else if (typeof item.colores === "string") {
                    colorId = item.colores;
                  } else if (item.colores._id) {
                    colorId = item.colores._id;
                  }
                }

                return {
                  propId: item._id, // _id de la proporción existente (para actualizar en vez de crear)
                  sizeId: sizeId,
                  colorId: colorId,
                  cantidad: item.cantidad,
                  ean: item.EAN || "",
                };
              })
              .filter((item) => item.sizeId && item.colorId); // Filter out any items with missing IDs

            console.log("Formatted amounts:", formattedAmounts);
            setAmounts(formattedAmounts);

            // Calculate total for piezasPorCaja
            const totalAmount = formattedAmounts.reduce(
              (acc, curr) => acc + (parseFloat(curr.cantidad) || 0),
              0
            );

            setPiezasPorCaja(totalAmount);
          }
        })
        .catch((err) => {
          console.log("Error loading pre-articulo data:", err);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No se pudo cargar la información del pre-modelo seleccionado.",
          });
        });
    }
  }, [preArticulo]);

  function coloresSeleccionados(checked, color) {
    if (checked) {
      setArrayColores([...arrayColores, { id: color._id, name: color.name }]);
    } else {
      const values = [...arrayColores];
      const indexToRemove = values.findIndex((t) => t.id === color._id);

      if (indexToRemove !== -1) {
        values.splice(indexToRemove, 1);
        setArrayColores(values);
      }
    }
  }

  function tallasSeleccionados(checked, talla) {
    if (checked) {
      setArrayTallas([...arrayTallas, { id: talla._id, name: talla.name }]);
    } else {
      const values = [...arrayTallas];
      const indexToRemove = values.findIndex((t) => t.id === talla._id);

      if (indexToRemove !== -1) {
        values.splice(indexToRemove, 1);
        setArrayTallas(values);
      }
    }
  }

  const saveArticulos = async (event) => {
    event.preventDefault();
    setValidaBoton(false);

    const arrayTallasOfIds = arrayTallas.map((talla) => talla.id);
    const arrayColoresOfIds = arrayColores.map((c) => c.id);

    let totalProporcion = amounts.length;

    let diferencialParsed = parseFloat(utilidadM);
    if (isNaN(diferencialParsed)) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Debes agregar el diferencial de margen!",
      });
    }

    if (piezasPorCaja == 0) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Debes agregar la proporcion de piezas por caja!",
      });
      setValidaBoton(true);
      return;
    }

    try {


    await axios.patch(
        `${URL_PRE_ARTICULOS}/${preArticulo}`,
        {
            codigo,
            nombre,
            piezasPorCaja,
            costoUSD,
            costoMX,
            venta,
            utilidadP: parseFloat(utilidadP) || 0,
            utilidadM: parseFloat(utilidadM) || 0,
            lista1: lista1,
            lista2: lista2,
            lista3: lista3,
            lista4: lista4,
            observaciones,
            lineas: selectedLinea,
            marcas: selectedMarca,
            familias: selectedFamilia,
            colecciones: selectedColeccion,
            proveedores: selectedProveedor,
            ano,
            EAN,
            precioEsp: "Si",
            colores: arrayColoresOfIds,
            tallas: arrayTallasOfIds,
            codigoSAT,
            codigoUnidad,
            esModelo: "Si",
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );

      await axios
        .post(
          URL_ARTICULOS,
          {
            codigo,
            nombre,
            piezasPorCaja,
            costoUSD,
            costoMX,
            venta,
            utilidadP: parseFloat(utilidadP) || 0,
            utilidadM: parseFloat(utilidadM) || 0,
            lista1: lista1,
            lista2: lista2,
            lista3: lista3,
            lista4: lista4,
            observaciones,
            lineas: selectedLinea,
            marcas: selectedMarca,
            familias: selectedFamilia,
            colecciones: selectedColeccion,
            proveedores: selectedProveedor,
            ano,
            EAN,
            precioEsp: "Si",
            colores: arrayColoresOfIds,
            tallas: arrayTallasOfIds,
            codigoSAT,
            codigoUnidad,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )

        .then((data) => {
          const articuloId = data.data._id;
          const authHeaders = {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          };

          amounts.map((a) => {
            // Si la proporción ya existe (venía del PreArticulo) -> ACTUALIZAR
            // agregándole el articulo, conservando su _id y su RFID (un solo doc por SKU).
            // Si es una combinación nueva (sin propId) -> crear (el backend asigna RFID).
            // OJO: el EAN vacío se OMITE del cuerpo — el validador del backend
            // rechaza EAN = "" y tiraba la petición completa en silencio (se
            // perdía la cantidad Y el ligado del artículo a la proporción).
            const bodyPatch = {
              articulos: articuloId,
              cantidad: parseFloat(a.cantidad) || 0,
            };
            if (a.ean && String(a.ean).trim() !== "") bodyPatch.EAN = a.ean;

            const bodyPost = {
              articulos: articuloId,
              cantidad: parseFloat(a.cantidad) || 0,
              colores: a.colorId,
              tallas: a.sizeId,
            };
            if (a.ean && String(a.ean).trim() !== "") bodyPost.EAN = a.ean;

            const request = a.propId
              ? axios.patch(`${URL_ARTICULOS_PROPORCION}/${a.propId}`, bodyPatch, authHeaders)
              : axios.post(URL_ARTICULOS_PROPORCION, bodyPost, authHeaders);

            request
              .then(() => {
                totalProporcion = totalProporcion - 1;
                if (totalProporcion == 0) {
                  axios.post(
                    URL_LOGS,
                    {
                      tipo: "Crear Modelo",
                      detalle: `${nombre} ${codigo}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  );
                  Swal.fire("Good job!", "Creado con exito", `success`);
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                }
              })
              .catch((error) => {
                console.log(error);
                setValidaBoton(true);
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
                });
              });
          });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
          });
          console.log(error);
          setValidaBoton(true);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
      });
      console.log(error);
    }
  };

  const handleInputChange = (sizeId, colorId, value, fieldType) => {
    const updatedAmounts = [...amounts];
    const existingEntryIndex = updatedAmounts.findIndex(
      (entry) => entry.sizeId === sizeId && entry.colorId === colorId
    );

    if (existingEntryIndex !== -1) {
      // Update existing entry
      if (fieldType === "amount") {
        updatedAmounts[existingEntryIndex].cantidad = value;
      } else if (fieldType === "ean") {
        updatedAmounts[existingEntryIndex].ean = value;
      }
    } else {
      // Create new entry with default values
      const newEntry = {
        sizeId: sizeId,
        colorId: colorId,
        tallas: sizeId,
        colores: colorId,
        cantidad: fieldType === "amount" ? value : 0,
        ean: fieldType === "ean" ? value : "",
      };
      updatedAmounts.push(newEntry);
    }

    setAmounts(updatedAmounts);

    // Calculate total for piezasPorCaja (only using the cantidad values)
    const totalAmount = updatedAmounts.reduce(
      (acc, curr) => acc + (parseFloat(curr.cantidad) || 0),
      0
    );

    setPiezasPorCaja(totalAmount);
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_articulos ? (
        <div className="card container">
          <h3 align="center">Convertir Pre Modelo a Modelo</h3>
          {/* <Get/> */}
          <Form onSubmit={saveArticulos}>
            <Row>
              <Col md={3}>
                <Label>Selecciona pre modelo</Label>
                <Autocomplete
                  size="small"
                  value={
                    preArticulos.find((a) => a._id === preArticulo) || null
                  }
                  onChange={(event, selectedOption) => {
                    setPreArticulo(
                      selectedOption ? selectedOption._id : ""
                    );
                  }}
                  options={preArticulos.sort((a, b) =>
                    a.codigo.localeCompare(b.codigo)
                  )}
                  getOptionLabel={(option) => option.codigo || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Buscar por código"
                      variant="outlined"
                    />
                  )}
                  renderOption={(props, option) => (
                    <li {...props} key={option._id}>
                      {option.codigo}
                    </li>
                  )}
                  isOptionEqualToValue={(option, value) =>
                    option._id === value._id
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Label>Numero de Modelo</Label>
                <Input
                  type="text"
                  placeholder="Codigo"
                  value={codigo}
                  required
                  onChange={(e) => {
                    setCodigo(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Nombre</Label>
                <Input
                  type="text"
                  placeholder="Nombre"
                  value={nombre}
                  required
                  onChange={(e) => {
                    setNombre(e.target.value);
                  }}
                />
              </Col>

              <Col md={3}>
                <Label>Piezas Por Caja</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  value={piezasPorCaja}
                  required
                  disabled
                />
              </Col>
              <Col md={3}>
                <Label>Código de barras</Label>
                <Input
                  type="text"
                  placeholder="Código de barras"
                  value={EAN}
                  required
                  onChange={(e) => {
                    setEAN(e.target.value);
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col md={3}>
                <Label>FOB USD</Label>
                <Input
                  type="text"
                  placeholder="FOB USD"
                  value={costoUSD}
                  required
                  onChange={(e) => {
                    setCostoUSD(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Costo MX</Label>
                <Input
                  type="text"
                  placeholder="Costo MX"
                  value={costoMX}
                  required
                  onChange={(e) => {
                    setCostoMX(e.target.value);
                  }}
                />
              </Col>

              <Col md={3}>
                <Label>Utilidad %</Label>
                <Input
                  type="number"
                  placeholder="Utilidad %"
                  value={utilidadP}
                  required
                  onChange={(e) => {
                    const value = parseFloat(e.target.value) || 0;
                    SetUtilidadP(value);
                    setLastChanged("utilidadP");
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Utilidad por monto </Label>
                <Input
                  type="number"
                  placeholder="Utilidad por monto"
                  value={utilidadM}
                  onChange={(e) => {
                    const value = parseFloat(e.target.value) || 0;
                    setUtilidadM(value);
                    setLastChanged("utilidadM");
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Venta</Label>
                <Input
                  type="text"
                  placeholder="Venta"
                  value={venta}
                  required
                  onChange={(e) => {
                    setVenta(e.target.value);
                  }}
                />
              </Col>

              <Col md={3}>
                <Label>Observaciones</Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Codigo SAT</Label>
                <Input
                  type="select"
                  placeholder="CodigoSAT"
                  value={codigoSAT}
                  required
                  onChange={(e) => {
                    setCodigoSAT(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="53101604">53101604 BLUSAS MUJER</option>
                  <option value="53102002"> 53102002 VESTIDOS, FALDAS, JUMPER </option>
                  <option value="53101504">53101504 PANTALONES MUJER</option>
                  <option value="53101804">53101804 CHAMARRAS MUJER</option>
                  <option value="53101704">53101704 SWEATER MUJER</option>
                  <option value="53103100">53103100 CHALECOS</option>
                  <option value="53102800">53102800 TRAJES DE BAÑO</option>
                  <option value="53101602">53101602 CAMISAS HOMBRE</option>
                  <option value="53101502">53101502 PANTALON HOMBRE</option>
                  <option value="52121500">52121500 COBIJA</option>
                  <option value="53101904">53101904 CONJUNTO</option>
                  <option value="53102304">53102304 SILICON BRA</option>
                  <option value="53102307">53102307 BODY TAPE</option>
                  <option value="53102501">53102501 CINTO</option>
                  <option value="53102502">53102502 BUFANDA/PAÑOLETA</option>
                  <option value="53102503">53102503 SOMBRERO</option>
                  <option value="53102516">53102516 GORRO/GORRA</option>
                  <option value="53121601">53121601 BOLSO/CARTERA</option>
                  <option value="53131633">53131633 PINZAS, BROCHES, PASADORES</option>
                  <option value="54101602">54101602 COLLAR</option>
                  <option value="53101601">53101601 PULSERA/BRAZALETE</option>
                  <option value="54101604">54101604 ARETE</option>
                  <option value="53101804">53101804 SACO</option>

                </Input>
              </Col>
              <Col md={3}>
                <Label>Codigo Unidad</Label>
                <Input
                  type="string"
                  placeholder="CodigoUnidad"
                  value={codigoUnidad}
                  required
                  onChange={(e) => {
                    setCodigoUnidad(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Linea</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedLinea}
                  required
                  onChange={(e) => {
                    setSelectedLinea(e.target.value);
                  }}
                >
                  <option value="0">Selecciona una Linea</option>
                  {lineas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return (
                        <option key={a._id} value={a._id}>
                          {a.name}
                        </option>
                      );
                    })}
                </Input>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Marca</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedMarca}
                  required
                  onChange={(e) => {
                    setSelectedMarca(e.target.value);
                  }}
                >
                  <option value="0">Selecciona una Marca</option>
                  {marcas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return (
                        <option key={a._id} value={a._id}>
                          {a.name}
                        </option>
                      );
                    })}
                </Input>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Familia</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedFamilia}
                  required
                  onChange={(e) => {
                    setSelectedFamilia(e.target.value);
                  }}
                >
                  <option value="0">Selecciona una Familia</option>
                  {familias
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return (
                        <option key={a._id} value={a._id}>
                          {a.name}
                        </option>
                      );
                    })}
                </Input>
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Coleccion</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedColeccion}
                  required
                  onChange={(e) => {
                    setSelectedColeccion(e.target.value);
                  }}
                >
                  <option value="0">Selecciona una Coleccion</option>
                  {colecciones
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return (
                        <option key={a._id} value={a._id}>
                          {a.name}
                        </option>
                      );
                    })}
                </Input>
              </Col>
              <Col md={3}>
                <Label>Año</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={ano}
                  required
                  onChange={(e) => {
                    setAno(e.target.value);
                  }}
                >
                  <option value="0">Selecciona un Año</option>
                  {years.map((a) => {
                    return (
                      <option key={a} value={a}>
                        {a}
                      </option>
                    );
                  })}
                </Input>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Proveedor</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedProveedor}
                  required
                  onChange={(e) => {
                    setSelectedProveedor(e.target.value);
                  }}
                >
                  <option value="0">Selecciona un Proveedor</option>
                  {proveedores
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => {
                      return (
                        <option key={a._id} value={a._id}>
                          {a.nombre_comercial}
                        </option>
                      );
                    })}
                </Input>
              </Col>
            </Row>
            <h4>Precios de Venta</h4>
            <Row>
              <Col md={3}>
                <Label>Lista 1</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  value={lista1}
                  required
                  onChange={(e) => {
                    setLista1(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Lista 2</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  value={lista2}
                  required
                  onChange={(e) => {
                    setLista2(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Lista 3</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  value={lista3}
                  required
                  onChange={(e) => {
                    setLista3(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Lista 4</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  value={lista4}
                  required
                  onChange={(e) => {
                    setLista4(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Agregar Colores
                </Label>
                <br />
                <Button
                  color="success"
                  id="Colores"
                  onClick={(e) => toggleColores()}
                >
                  <i className="fas fa-palette fa-2x "></i>
                </Button>
              </Col>
              <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Agregar Tallas
                </Label>
                <br />
                <Button
                  color="success"
                  id="Tallas"
                  onClick={(e) => toggleTallas()}
                >
                  <i className="fas fa-ruler-horizontal fa-2x "></i>
                </Button>
              </Col>
            </Row>

            <Row className="w-full">
              <div className="bg-white shadow-md rounded-lg overflow-hidden border border-gray-200 w-full">
                <div className="p-6 bg-gray-50">
                  <Label className="text-xl font-semibold text-gray-800 mb-4 block">
                    Proporcion
                  </Label>

                  {/* Enhanced scrollable container */}
                  <div
                    style={{
                      width: "100%",
                      overflowX: "auto",
                      WebkitOverflowScrolling: "touch",
                      display: "block",
                      maxWidth: "100%",
                    }}
                  >
                    <table
                      style={{
                        minWidth: "1200px",
                        width: "100%",
                        borderCollapse: "collapse",
                      }}
                    >
                      <thead>
                        {/* Size Names Row */}
                        <tr>
                          <th
                            className="border py-3 px-4 text-center font-medium text-gray-600"
                            style={{
                              width: "200px",
                              position: "sticky",
                              left: 0,
                              zIndex: 10,
                              backgroundColor: "white",
                              color: "gray",
                            }}
                          ></th>
                          {[...arrayTallas]
                            .sort((a, b) => {
                              const indexA = customSizeOrder.indexOf(a.name);
                              const indexB = customSizeOrder.indexOf(b.name);
                              if (indexA === -1 && indexB === -1) return 0;
                              if (indexA === -1) return 1;
                              if (indexB === -1) return -1;
                              return indexA - indexB;
                            })
                            .map((size) => (
                              <th
                                key={size.id}
                                className="border py-2 px-4 text-center font-medium text-gray-600"
                                colSpan="2"
                              >
                                <div
                                  className="text-lg border border-gray-300 rounded-t-lg py-2 bg-gray-100"
                                  style={{ color: "gray" }}
                                >
                                  {size.name}
                                </div>
                              </th>
                            ))}
                        </tr>

                        {/* Column Headers Row */}
                        <tr>
                          <th
                            className="border py-2 px-4 text-left font-medium text-gray-500"
                            style={{
                              position: "sticky",
                              left: 0,
                              zIndex: 10,
                              backgroundColor: "white",
                              color: "gray",
                            }}
                          ></th>
                          {[...arrayTallas]
                            .sort((a, b) => {
                              const indexA = customSizeOrder.indexOf(a.name);
                              const indexB = customSizeOrder.indexOf(b.name);
                              if (indexA === -1 && indexB === -1) return 0;
                              if (indexA === -1) return 1;
                              if (indexB === -1) return -1;
                              return indexA - indexB;
                            })
                            .map((size) => (
                              <React.Fragment key={`header-${size.id}`}>
                                <th
                                  className="border py-2 px-1 text-center text-xs font-medium text-gray-500 bg-gray-50"
                                  style={{
                                    width: "80px",
                                    color: "gray",
                                  }}
                                >
                                  CANTIDAD
                                </th>
                                <th
                                  className="border py-2 px-3 text-center text-xs font-medium text-gray-500 bg-gray-50"
                                  style={{
                                    width: "240px",
                                    color: "gray",
                                  }}
                                >
                                  CÓDIGO DE BARRAS
                                </th>
                              </React.Fragment>
                            ))}
                        </tr>
                      </thead>
                      <tbody>
                        {arrayColores.map((color, colorIndex) => (
                          <tr
                            key={color.id}
                            className={`${
                              colorIndex % 2 === 0 ? "bg-white" : "bg-gray-50"
                            } hover:bg-gray-100 transition-colors`}
                          >
                            <td
                              className="border py-3 px-4 text-gray-700 font-medium"
                              style={{
                                position: "sticky",
                                left: 0,
                                zIndex: 5,
                                backgroundColor:
                                  colorIndex % 2 === 0 ? "white" : "#f9fafb",
                                color: "gray",
                              }}
                            >
                              <div className="flex items-center">
                                <div
                                  className="w-4 h-4 rounded-full mr-3"
                                  style={{
                                    backgroundColor: color.name.toLowerCase(),
                                    color: "gray",
                                  }}
                                ></div>
                                <span className="uppercase">{color.name}</span>
                              </div>
                            </td>
                            {[...arrayTallas]
                              .sort((a, b) => {
                                const indexA = customSizeOrder.indexOf(a.name);
                                const indexB = customSizeOrder.indexOf(b.name);
                                if (indexA === -1 && indexB === -1) return 0;
                                if (indexA === -1) return 1;
                                if (indexB === -1) return -1;
                                return indexA - indexB;
                              })
                              .map((size) => {
                                const entry = amounts.find(
                                  (entry) =>
                                    entry.sizeId === size.id &&
                                    entry.colorId === color.id
                                );
                                const cantidad = entry?.cantidad || 0;
                                const ean = entry?.ean || "";

                                return (
                                  <React.Fragment
                                    key={`${color.id}-${size.id}`}
                                  >
                                    <td className="border py-2 px-1 text-center">
                                      <input
                                        type="number"
                                        min="0"
                                        step="any"
                                        value={cantidad}
                                        onChange={(e) =>
                                          handleInputChange(
                                            size.id,
                                            color.id,
                                            e.target.value,
                                            "amount"
                                          )
                                        }
                                        className="w-full border border-gray-300 rounded-lg p-2 text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        placeholder="0"
                                      />
                                    </td>
                                    <td className="border py-2 px-3 text-center">
                                      <input
                                        type="text"
                                        value={ean}
                                        onChange={(e) =>
                                          handleInputChange(
                                            size.id,
                                            color.id,
                                            e.target.value,
                                            "ean"
                                          )
                                        }
                                        className="w-full border border-gray-300 rounded-lg p-2 text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        placeholder="Código de barras"
                                      />
                                    </td>
                                  </React.Fragment>
                                );
                              })}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </Row>
            <br />
            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoPreArticulos"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />

          <Modal size="lg" isOpen={modalColores} toggle={toggleColores}>
            <ModalHeader toggle={toggleColores}>
              <h4>Colores del Modelo {nombre}</h4>
            </ModalHeader>
            <ModalBody>
              {colores
                .sort((a, b) => (a.name > b.name ? 1 : -1))
                .map((a, index) => {
                  // Check if this color is already selected
                  const isChecked = arrayColores.some(
                    (color) => color.id === a._id
                  );

                  return (
                    <table key={index}>
                      <tbody>
                        <tr>
                          <td>
                            <Input
                              type="checkbox"
                              checked={isChecked}
                              onChange={(e) => {
                                coloresSeleccionados(
                                  e.currentTarget.checked,
                                  a
                                );
                              }}
                              className="subMenu"
                            />
                            <h5 className="subMenuTitulo">{a.name}</h5>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  );
                })}
            </ModalBody>
          </Modal>

          <Modal size="lg" isOpen={modalTallas} toggle={toggleTallas}>
            <ModalHeader toggle={toggleTallas}>
              <h4>Tallas del Modelo {nombre}</h4>
            </ModalHeader>
            <ModalBody>
              {tallas
                .sort((a, b) => {
                  const indexA = customSizeOrder.indexOf(a.name);
                  const indexB = customSizeOrder.indexOf(b.name);

                  // If either size is not in the customSizeOrder, maintain original order
                  if (indexA === -1 && indexB === -1) return 0;
                  if (indexA === -1) return 1;
                  if (indexB === -1) return -1;

                  // Sort according to the custom order
                  return indexA - indexB;
                })
                .map((a, index) => {
                  // Check if this size is already selected
                  const isChecked = arrayTallas.some(
                    (size) => size.id === a._id
                  );

                  return (
                    <table key={index}>
                      <tbody>
                        <tr>
                          <td>
                            <Input
                              type="checkbox"
                              checked={isChecked}
                              onChange={(e) => {
                                tallasSeleccionados(e.currentTarget.checked, a);
                              }}
                              className="subMenu"
                            />
                            <h5 className="subMenuTitulo">{a.name}</h5>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  );
                })}
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default ConvertirArticulos;
